// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3zGHS","errorLogs":"styles_errorLogs__2uUye"};